import { Controller } from 'react-hook-form';
import { Input } from '../../../../components/common/Input';
import { FilterViewModel } from '../../../../types/domain';

type TextBoxFilterProps = {
  filter: FilterViewModel;
  fieldName: string;
  control: any;
};

export const TextBoxFilter = ({ filter, fieldName, control }: TextBoxFilterProps) => {
  return (
    <Controller
      name={fieldName}
      control={control}
      defaultValue={['']}
      rules={{ maxLength: { value: 250, message: 'Maximum length is 250 characters' } }}
      render={({ field, fieldState }) => (
        <div>
          <Input
            value={(field.value && field.value[0]) || ''}
            onChange={(e) => field.onChange([(e.target as HTMLInputElement).value])}
            maxLength={250}
            placeholder={`Enter ${filter.name.toLowerCase()}`}
          />
          {fieldState.error && (
            <div className="text-sm text-red-600 mt-1">{fieldState.error.message}</div>
          )}
        </div>
      )}
    />
  );
};